import React, { Component } from 'react';
const d3 = window.d3;
import * as d3tip from 'd3-tip';
import Fetch from '../../common/fetch';
import { Auth } from 'aws-amplify';
import './styles.css';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

class BarChart extends Component {
    constructor(props) {
        super(props);
        // Fetch information to display from the RDS database
        this.fetch = new Fetch();
        this.state = {
            isLoaded: false,
            // Need to get 2 pieces of information, energy the user consumed and average energy consumption
            energyUser: {},
            energyMean: {}
        }
    }

    /**
     * componentDidMount() is invoked immediately after a component is mounted.
     * After this.data is loaded, render the bar chart
     */
    async componentDidMount() {
        const energyUser = await this.getEnergyUser();
        const energyMean = await this.getEnergyMean();
        this.data = this.mergeDataset(energyUser, energyMean);
        this.setState({ isLoaded: true });

        this.renderGraph();
        // The chart is resized when window size is changed
        window.addEventListener('resize', this.resize.bind(this));
    }

    // Merge both energy values into 1 dataset
    mergeDataset(energyUser, energyMean) {
        const dataset = months.reduce((acc, cur, index) => {
            const user = energyUser.find(element => element.month === index + 1);
            const mean = energyMean.find(element => element.month === index + 1);

            const data = { Month: cur, 'Most Efficient': mean.energy, You: user.energy };
            acc.push(data);
            return acc;
        }, []);

        return dataset;
    }

    /**
     * This function gets a token from Cognito and made sure the user is logged in and authenticated. 
     * The AWS API Gateway route is /dev/energy/user, this function calls the backend query with assigned 'site' number. 
     */
    async getEnergyUser() {
        const user = await Auth.currentAuthenticatedUser();
        const { jwtToken } = user.signInUserSession.idToken;

        const url = `https://mv9av9jew4.execute-api.us-east-1.amazonaws.com/dev/energy/user?site=${this.props.site}`;
        const options = {
            method: 'GET',
            headers: {
                authorization: jwtToken
            }
        };

        return await this.fetch.request(url, options);
    }

    // The AWS API Gateway route is /dev/energy/mean
    async getEnergyMean() {
        const user = await Auth.currentAuthenticatedUser();
        const { jwtToken } = user.signInUserSession.idToken;

        const url = 'https://mv9av9jew4.execute-api.us-east-1.amazonaws.com/dev/energy/mean';
        const options = {
            method: 'GET',
            headers: {
                authorization: jwtToken
            }
        };

        return await this.fetch.request(url, options);
    }




    // The chart is resized when window size is changed
    // After window size is changed, the bar chart and all it's values need to be re-rendered
    resize() {
        const windowWidth = window.innerWidth;
        var setWidth;
        // When window is small, stack graphs on the top of each other
        if (windowWidth < 1600) {
            setWidth = window.$(`.${this.props.appendBar}`).width();
        } else {
            setWidth = window.innerWidth * 0.4
        }

        var margin = { top: 20, right: 20, bottom: 30, left: 40 },
            width = setWidth - margin.left - margin.right, // 450
            height = 350 - margin.top - margin.bottom; //450
        // x-axis: create the ordinal scale for months
        var x0 = d3.scaleBand().rangeRound([0, width]).padding(0.1);
        // x-axis: define Most Efficient and You elements on the right
        var x1 = d3.scaleBand();
        // define y-axis
        var y = d3.scaleLinear().range([height, 0]);
        // colors for ordinal x-axis, there are two colors 
        var color = d3.scaleOrdinal().range(['#0571b0', '#d5d5d5']);
        // x function
        var xAxis = d3.axisBottom(x0).ticks(0)
        // y function
        var yAxis = d3.axisLeft(y)

        window.$(`.${this.props.appendBar} svg`)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)

        var compareGroups = d3.keys(this.data[0]).filter(function (key) { return key !== 'Month'; });
        // Get number values when user hover the bar chart
        const tip = this.getToolTipValue();

        // x0 is the list of all of the months
        x0.domain(this.data.map(function (d) { return d.Month; }));
        // x1 is the list of all groups for each month
        x1.domain(compareGroups).rangeRound([0, x0.bandwidth()]);
        y.domain([0, d3.max(this.data, function (d) { return d3.max(d.groups, function (d) { return d.value; }); })]);

        this.svg.select('.x.axis').call(xAxis)
        this.svg.select('.y.axis').call(yAxis)

        // Remove the old bars
        this.svg.selectAll('rect').remove();


        // bind the JavaScript Objects to SVG Group Elements, which is month
        this.month = this.svg.selectAll('.month')
            .data(this.data)
            .enter()
            .append('g')
            .attr('class', 'g')
            .attr('transform', function (d) { return 'translate(' + x0(d.Month) + ',0)'; });
        // construct rectangles
        this.month.selectAll('rect')
            .data(function (d) { return d.groups; })
            .enter()
            .append('rect')
            .attr('width', x1.bandwidth())
            .attr('x', function (d) { return x1(d.name); })
            .style('fill', function (d) { return color(d.name); })
            .on('mouseover', function (d) {
                d3.select(this).style('fill', d3.rgb(color(d.name)).darker(1));
                tip.show(d, this);
            })
            .on('mouseout', function (d) {
                d3.select(this).style('fill', color(d.name));
                tip.hide(d, this);
            });

        // set height of each bar
        this.month.selectAll('rect')
            .attr('y', function (d) { return y(d.value); })
            .attr('height', function (d) { return (height - y(d.value)); });


        // Remove the old legend
        this.svg.selectAll('.legend').remove();
        // construct the legend for the chart
        this.legend = this.svg.selectAll('.legend')
            .data(compareGroups.slice(0, -1))
            .enter()
            .append('g')
            .attr('class', 'legend')
            .attr('transform', function (d, i) { return 'translate(0,' + i * 20 + ')'; })
            .style('opacity', '1');
        // add small rectangles with associated name and color
        this.legend.append('rect')
            .attr('x', width - 18)
            .attr('width', 18)
            .attr('height', 18)
            .style('fill', function (d) { return color(d); });

        this.legend.append('text')
            .attr('x', width - 24)
            .attr('y', 9)
            .attr('dy', '.35em')
            .style('text-anchor', 'end')
            .style('font-size', '14px')
            .text(function (d) { return d; });

    } // resize

    getToolTipValue() {
        // tooltip of values
        const tip = new d3tip.default().html(({ value }) => value)
        this.svg.call(tip);

        return tip;
    }


    // rendering graph when the page is first loaded, similar code with resize() function
    async renderGraph() {

        // define margin, width and height
        const windowWidth = window.innerWidth;
        var setWidth;
        if (windowWidth < 1600) {
            setWidth = window.$(`.${this.props.appendBar}`).width();
        } else {
            setWidth = window.innerWidth * 0.4
        }

        var margin = { top: 20, right: 20, bottom: 30, left: 40 },
            width = setWidth - margin.left - margin.right, // 450
            height = 350 - margin.top - margin.bottom; //450

        // x-axis: create the ordinal scale for months
        var x0 = d3.scaleBand().rangeRound([0, width]).padding(0.1);
        // x-axis: define Most Efficient and You elements on the right
        var x1 = d3.scaleBand();
        // define y-axis
        var y = d3.scaleLinear().range([height, 0]);
        // colors for ordinal x-axis
        var color = d3.scaleOrdinal().range(['#0571b0', '#d5d5d5']);
        // x function
        var xAxis = d3.axisBottom(x0).ticks(0)
        // y function
        var yAxis = d3.axisLeft(y)

        // create svg container and inner drawing space
        this.svg = d3.select(`.${this.props.appendBar}`).append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);
        // asynchronous call to the server to get the data and then builds the chart


        var compareGroups = d3.keys(this.data[0]).filter(function (key) { return key !== 'Month'; });

        this.data.forEach(function (d) {
            d.groups = compareGroups.map(function (name) { return { name: name, value: +d[name] }; });
        });

        const tip = this.getToolTipValue();

        // x0 is the list of all of the months
        x0.domain(this.data.map(function (d) { return d.Month; }));
        // x1 is the list of all groups for each month
        x1.domain(compareGroups).rangeRound([0, x0.bandwidth()]);
        y.domain([0, d3.max(this.data, function (d) { return d3.max(d.groups, function (d) { return d.value; }); })]);

        // create the full X and Y axis
        this.svg.append('g')
            .attr('class', 'x axis')
            .style('font-size', '14px')
            .call(xAxis);

        this.svg.append('g')
            .attr('class', 'y axis')
            .style('opacity', '0')
            .call(yAxis)
            .append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 6)
            .attr('dy', '.71em')
            .style('fill', 'black')
            .style('font-size', '14px')
            .style('text-anchor', 'end')
            .text('Energy');
        // add Y axis animation
        this.svg.select('.y')
            .transition()
            .duration(300)
            .delay(300)
            .style('opacity', '1')
            .style('font-size', '14px');

        // bind the JavaScript Objects to SVG Group Elements, which is month
        this.month = this.svg.selectAll('.month')
            .data(this.data)
            .enter()
            .append('g')
            .attr('class', 'g')
            .attr('transform', function (d) { return 'translate(' + x0(d.Month) + ',0)'; });
        // construct rectangles
        this.month.selectAll('rect')
            .data(function (d) { return d.groups; })
            .enter()
            .append('rect')
            .attr('width', x1.bandwidth())
            .attr('x', function (d) { return x1(d.name); })
            .attr('y', function () { return y(0); })
            .attr('height', function () { return height - y(0); })
            .style('fill', function (d) { return color(d.name); })
            .on('mouseover', function (d) {
                d3.select(this).style('fill', d3.rgb(color(d.name)).darker(1));
                tip.show(d, this);
            })
            .on('mouseout', function (d) {
                d3.select(this).style('fill', color(d.name));
                tip.hide(d, this);
            });

        this.month.selectAll('rect')
            .transition()
            .delay(function () { return Math.random() * 100; })
            .duration(300)
            .attr('y', function (d) { return y(d.value); })
            .attr('height', function (d) { return height - y(d.value); });

        // construct the legend for the chart
        this.legend = this.svg.selectAll('.legend')
            .data(compareGroups.slice())
            .enter()
            .append('g')
            .attr('class', 'legend')
            .attr('transform', function (d, i) { return 'translate(0,' + i * 20 + ')'; })
            .style('opacity', '0');
        // add small rectangles
        this.legend.append('rect')
            .attr('x', width - 18)
            .attr('width', 18)
            .attr('height', 18)
            .style('fill', function (d) { return color(d); });

        this.legend.append('text')
            .attr('x', width - 24)
            .attr('y', 9)
            .attr('dy', '.35em')
            .style('text-anchor', 'end')
            .style('font-size', '14px')
            .text(function (d) { return d; });
        // add small rectangle animation
        this.legend.transition()
            .duration(300)
            .delay(function (d, i) { return 300 + 100 * i; })
            .style('opacity', '1');
    } // renderGraph

    /**
     * When data is not loaded show spinner animation.
     * Show the barchart when data is loaded.
     */
    render() {
        const { isLoaded } = this.state;
        if (!isLoaded) {
            return (
                <div className='d-flex justify-content-center'>
                    <div className='spinner-border text-info' style={{ width: '3rem', height: '3rem' }}></div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className={this.props.appendBar} ref={this.myRef}></div>
                </div>
            );
        }
    }
}
export default BarChart;


// WEBPACK FOOTER //
// ./src/components/bar-chart/index.js